import { render, staticRenderFns } from "./OrdersLegacy.vue?vue&type=template&id=86336ca6&"
import script from "./OrdersLegacy.vue?vue&type=script&lang=ts&"
export * from "./OrdersLegacy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports